import { gql, useMutation } from '@apollo/client';
import { GET_CURRENT_SUBSCRIPTION } from './get-current-subscription.hook';

const CHANGE_SUBSCRIPTION_PAYMENT_METHOD = gql`
  mutation ($stripeSubscriptionId: String!, $paymentMethodId: String!) {
    changeSubscriptionPaymentMethod(
      stripeSubscriptionId: $stripeSubscriptionId
      paymentMethodId: $paymentMethodId
    ) {
      _id
    }
  }
`;

export const useChangeSubscriptionPaymentMethod = ({ onSuccess }: { onSuccess: () => void }) => {
  const [changePaymentMethod, { loading }] = useMutation(CHANGE_SUBSCRIPTION_PAYMENT_METHOD, {
    refetchQueries: [GET_CURRENT_SUBSCRIPTION],
    onCompleted: onSuccess,
  });

  return {
    loading,
    updatePaymentMethod: (payload: any) => changePaymentMethod({ variables: { ...payload } }),
  };
};
